import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
	button: {
		// float: 'right',
		[useTheme().breakpoints.down('sm')]: {
			padding: useTheme().spacing(1),
		},
		'& .breadcrumb': {
			marginBottom: '30px',
			[useTheme().breakpoints.down('sm')]: { marginBottom: '16px' },
		},
		'& .button': { margin: useTheme().spacing(1) },
		'& .input': { display: 'none' },
	},
}));
export default styles;
